export const Colors = {
  brickRed: "#CD512C",
  deepBlack: "#4E4E4E",
  lightGrey: "#939393",
  black: "#000000",
  davyGrey: "#525c60",
  secondaryBlack: "#333333",
  beachAlley: "#33CCCC",
};
